import { useCallback, useState } from 'react';

const STORAGE_PREFIX = 'ss-print-panel-collapsed:';

// Same shape as useState(false), but the value survives a browser refresh
// via localStorage. Each print-designer sidebar panel passes its own unique
// key (e.g. 'position', 'grid-layout') so panels don't clobber each other.
export default function usePersistedCollapse(key, defaultValue = false) {
  const storageKey = STORAGE_PREFIX + key;

  const [collapsed, setCollapsedState] = useState(() => {
    try {
      const stored = window.localStorage.getItem(storageKey);
      return stored === null ? defaultValue : stored === 'true';
    } catch {
      return defaultValue;
    }
  });

  const setCollapsed = useCallback((value) => {
    setCollapsedState(value);
    try {
      window.localStorage.setItem(storageKey, String(value));
    } catch {
      // Storage unavailable (e.g. private browsing) — state still works
      // for the current session, it just won't persist.
    }
  }, [storageKey]);

  return [collapsed, setCollapsed];
}
